export const CM_PER_INCH = 2.54;

export const DEFAULT_PAGE_WIDTH_CM = 7;
export const DEFAULT_PAGE_HEIGHT_CM = 5;

export function detectDefaultLengthUnit() {
  return 'cm';
}

export function cmToIn(cm) {
  return Number(cm) / CM_PER_INCH;
}

export function inToCm(inches) {
  return Number(inches) * CM_PER_INCH;
}

/** Format stored cm value for an input field in the active unit. */
export function formatLengthForInput(cm, unit) {
  const value = unit === 'in' ? cmToIn(cm) : Number(cm);
  if (!Number.isFinite(value)) return '';
  // Keep a few decimals for inches; cm can be cleaner
  const rounded = unit === 'in'
    ? Math.round(value * 1000) / 1000
    : Math.round(value * 100) / 100;
  return String(rounded);
}

/** Parse user input in the active unit back to centimeters. */
export function parseLengthToCm(value, unit) {
  const num = Number(value);
  if (!Number.isFinite(num)) return NaN;
  return unit === 'in' ? inToCm(num) : num;
}
